// extracted by mini-css-extract-plugin
export default {"root":"IconVisa_root__NaQHG"};